import { format } from "date-fns";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { HiOutlineCurrencyDollar } from "react-icons/hi";
import { RiShoppingCart2Line } from "react-icons/ri";
import { CheckBox } from "devextreme-react";
import { FaRegEdit } from 'react-icons/fa'
import { FaCheck } from "react-icons/fa6";
import { useState } from "react";
import useLoadingContractors from "../../../Components/ContractorsPage/useLoadingContractors";
import { toast } from "react-toastify";
import { useCustomer } from "../../../Providers/CustomerProvider";
import { useAuth } from "../../../Providers/AuthProvider";
import TableLoadingSpinner from "../../../Components/Components/TableLoadingSpinner";
import SelectBox from 'devextreme-react/select-box'

const Contractor = ({ contractor, isSelected, handleCustomerChecked, lastBookElementRef = null, setShowMessageCalculatePriceList, setCustIdToGeneratePriceList,
    setContractorHasPriceList, customerDiscounts }) => {
    const { authState } = useAuth()
    const [isDiscountEdit, setIsDiscountEdit] = useState(false)
    const [initialDiscount, setInitialDiscount] = useState(contractor.discount)
    const [discount, setDiscount] = useState(contractor.discount)
    const { handleChangeContractorDiscount } = useLoadingContractors(null, null)
    const { handleAddTaskForSendPriceListNow } = useCustomer()
    const [lockEditDiscount, setLockEditDiscount] = useState(false) //DK : Blokada w trakcie inserttu        

    let formattedDate = ""
    if (contractor.priceListGenerateDate !== "0001-01-01T00:00:00") {
        const dateObj = new Date(contractor.priceListGenerateDate)
        formattedDate = format(dateObj, "dd.MM.yyyy HH:mm")
    }

    const popover = formattedDate ?
        <Popover id="popover-basic">
            <Popover.Body className="text-center">
                <div className='d-flex flex-column'>
                    <span className='primary-accent-color-text'>Wywołaj natychmiastowe przeliczenie cennika</span>
                    <span className='primary-accent-color-text'>{`Data ostatniego cennika: ${formattedDate}`}</span>
                </div>

            </Popover.Body>
        </Popover>
        :
        <Popover id="popover-basic">
            <Popover.Body className="text-center">
                <span className='primary-accent-color-text'>Wywołaj natychmiastowe przeliczenie cennika</span>
            </Popover.Body>
        </Popover>

    const popoverBasketIcon = <Popover id="popover-basic">
        <Popover.Body className="text-center">
            <span className='primary-accent-color-text'>Kontrahent ma zapisany koszyk</span>
        </Popover.Body>
    </Popover>

    const handleConfirmNewDiscount = async () => {
        if (!lockEditDiscount) {
            setLockEditDiscount(true)
            if (initialDiscount == discount) {
                setIsDiscountEdit(false)
                setLockEditDiscount(false)
                return
            }
            let res = await handleChangeContractorDiscount(contractor.recNo, discount, initialDiscount, contractor.custId, authState.user.kod,
                authState.user.userLogin)
            if (res) {
                await handleAddTaskForSendPriceListNow(contractor.custId)
                toast.success('Pomyślnie zaktualizowano dane. Wysłano zadanie wygenerowania nowego cennika dla kontrahenta!')
                setInitialDiscount(discount)
            }
            else {
                setDiscount(initialDiscount)
                toast.error('Błąd w trakcie edycji danych!')
            }
            setIsDiscountEdit(false)
            setLockEditDiscount(false)
        }
    }

    const handleDiscountEditClick = () => {
        if (!authState.user?.upR_SYS_EDYCJA_RABATU_KONTRAHENTA) {
            toast.warning('Brak uprawnień do edycji rabatu klienta!')
            return
        }
        setIsDiscountEdit(true)
    }

    return (
        <tr id={contractor.custId} ref={lastBookElementRef}>
            <td>
                <CheckBox
                    className="custom-checkbox"
                    value={isSelected}
                    onValueChange={() => handleCustomerChecked(contractor)}
                />
            </td>
            <td>{contractor.name}</td>
            <td>{contractor.nip}</td>
            <td>{contractor.custAccount}</td>
            <td>{contractor.custNumber}</td>
            <td>{contractor.salesTeam}</td>
            <td>{contractor.address}</td>
            {lockEditDiscount ?
                (<td>
                    <TableLoadingSpinner />
                </td>)
                :
                (<td>
                    {isDiscountEdit ? (
                        <div className="d-flex align-items-center w-100">
                            <SelectBox
                                className="flex-fill me-2"
                                value={discount}
                                dataSource={customerDiscounts}
                                onValueChanged={(e) => setDiscount(e.value)}
                                displayExpr={(item) => (item !== null && item !== undefined ? `${item}` : "")}
                                onEnterKey={handleConfirmNewDiscount}
                                placeholder=""
                            />
                            <FaCheck size={15} className="element-pointer" color="var(--success-color)" onClick={() => handleConfirmNewDiscount()} />
                        </div>
                    ) : (
                        <div className="d-flex align-items-center justify-content-between w-100">
                            <span>{`${discount !== null && discount !== undefined ? discount : 0}`}</span>
                            <FaRegEdit className="element-pointer ms-2" size={15} onClick={handleDiscountEditClick} />
                        </div>
                    )}
                </td>)}
            <td>
                <OverlayTrigger trigger={["hover", "focus"]} placement="bottom" overlay={popover}>
                    <span>
                        <HiOutlineCurrencyDollar
                            size={28}
                            color="black"
                            cursor={'pointer'}
                            onClick={() => {
                                setCustIdToGeneratePriceList(contractor.custId)
                                setContractorHasPriceList(contractor.priceListGenerateDate === "0001-01-01T00:00:00" ? false : true)
                                setShowMessageCalculatePriceList(true)
                            }} />
                    </span>
                </OverlayTrigger>
            </td>
            <td>
                {contractor.hasSavedBasket &&
                    <OverlayTrigger trigger={["hover", "focus"]} placement="bottom" overlay={popoverBasketIcon}>
                        <div>
                            <RiShoppingCart2Line color="var(--primary)" size={28} />
                        </div>
                    </OverlayTrigger>}
            </td>
        </tr>
    )
};

export default Contractor;
